module.exports = __webpack_public_path__ + "assets/img/pz4.8f25c550.png";